import SuperAdmin from '@/views/SuperAdmin/index.vue';

import store from '@/store';

const VALID_ROLES = ['admin', 'totalplay'];

async function beforeEnter(to, from, next) {
  const { role } = store.state.auth;

  if (VALID_ROLES.includes(role)) next();
  else next({ name: 'Home' });
}

export default [
  {
    path: '/super-admin',
    name: 'SuperAdmin',
    component: SuperAdmin,
    meta: { auth: true },
    redirect: { name: 'UsersList' },
    children: [
      {
        path: 'users/list',
        name: 'UsersList',
        component: () => import(/* webpackChunkName: "users-list" */ '@/views/SuperAdmin/Users/List.vue'),
      },
      {
        path: 'users/new',
        name: 'NewUser',
        component: () => import(/* webpackChunkName: "new-user" */ '@/views/SuperAdmin/Users/New.vue'),
      },
      {
        path: 'users/bulk-upload/status',
        name: 'UserBulkLoadStatus',
        component: () => import(/* webpackChunkName: "user-bulk-upload-status" */ '@/components/SuperAdmin/UserBulkLoadStatus.vue'),
      },
      {
        path: 'users-csv-load',
        name: 'UsersCsvLoad',
        component: () => import(/* webpackChunkName: "users-csv-load" */ '@/components/SuperAdmin/UsersCsvLoad.vue'),
      },
      {
        path: 'find-user',
        name: 'FindUser',
        component: () => import(/* webpackChunkName: "find-user" */ '@/components/SuperAdmin/FindUser.vue'),
      },
      {
        path: 'update-user',
        name: 'UpdateUser',
        component: () => import(/* webpackChunkName: "update-user" */ '@/components/SuperAdmin/UpdateUser.vue'),
      },
    ].map((route) => {
      route.beforeEnter = beforeEnter;

      return route;
    }),
  },
];
